import React from 'react';
import styled from 'styled-components';
import FloatInputContainer from '../TextInput/FloatInputContainer';
import DropdownWrapper from '../Dropdown/DropdownWrapper';
import DropdownLaunch from '../Dropdown/DropdownLaunch';
import DropdownContent from '../Dropdown/DropdownContent';

const NoItems = styled.div`
    cursor: pointer;
    padding: 10px;
    &:hover{
        background-color: #E0F3FB;
    }
    font-size: inherit;
`;

const Caret = styled.div`
    width: 0; 
    height: 0; 
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #d9d9d9;
    float: right;
    margin-top: -15px;
`

const SelectedDropdownItem = styled.div`
    border-bottom: 1px solid rgba(0,0,0,0.15);
    cursor: pointer;
    user-select: none;
    /*font-weight: 700;*/
    font-size: inherit;
`;

interface SelectorComponentProps {
    showSelected?: boolean,
    isFilterable?: boolean,
    selectedItem: any,
    renderSelectedItem: (item: any) => any,
    selectItemAction?,
    onListFocus?,
    onHideList?,
    isListVisible?: boolean,
    onFilterChange?: (evt: any) => void,
    filter?: any,
    label?,
    renderItems,
    items,
    placeHolder?,
    isDarkMode?: boolean,
    isOpenAction?: (a: boolean) => void,
    fitToSize?: boolean,
    showDropdown?: (b: boolean) => void
}

const SelectorComponent = ({
    showSelected = true,
    isFilterable = false,
    selectedItem,
    renderSelectedItem,
    selectItemAction = null,
    onListFocus = null,
    onHideList = null,
    isListVisible = false,
    onFilterChange = (e) => {},
    filter = null,
    label = '',
    renderItems,
    items,
    placeHolder = '',
    isDarkMode = false,
    isOpenAction = (val) => {},
    fitToSize = true,
    showDropdown = (val) => {}
}: SelectorComponentProps) => {

    const renderedItems = renderItems(items, selectItemAction);

    let selectedItemDisplay = label;

    if (showSelected && selectedItem && renderSelectedItem) {

        selectedItemDisplay = renderSelectedItem(selectedItem);
    }
    return (<DropdownWrapper isOpenAction={isOpenAction} fitToSize={fitToSize}>
        <DropdownLaunch isDropdownOpen={isListVisible} setDropDownOpen={(e) => showDropdown(!isListVisible)}>
            {(showSelected) ?
                <SelectedDropdownItem>{selectedItemDisplay ? selectedItemDisplay : label}</SelectedDropdownItem>
                : isFilterable ? <FloatInputContainer
                    changeAction={(e) => onFilterChange(e)}
                    value={filter}
                    autoFocus={true}
                    label={label}
                    isDarkMode={isDarkMode}
                    placeHolder={placeHolder}
                    showErrors={false}
                    isValid={false}
                    invalidMessages={undefined}
                /> : <SelectedDropdownItem>{placeHolder}</SelectedDropdownItem>}
            <Caret />
        </DropdownLaunch>
        <DropdownContent
            fitToSize={fitToSize}
            closeOnClick={true}
        >
            {items.length > 0 ? renderedItems : <NoItems>No items</NoItems>}
        </DropdownContent>
    </DropdownWrapper>
    );

}

export default SelectorComponent;
